import Vue from "vue";
import Vuex from "vuex";
/* import router from "../router"; */
import axios from "axios";
import http from "../services/http";
import subcategoriasService from "../services/subcategoriasService";
import user from "./modules/user";
import users from "./modules/users";
import productos from "./modules/productos";
import marcas from "./modules/marcas";
import pedidosModule from "./modules/pedidosModule";
import customers from "./modules/customers";
import listasPrecio from "./modules/listasPrecio"; // Importamos el módulo de listas de precio
import pos from "./modules/pos";
import discountCodes from "./modules/discountCodes";
import tiposCarne from "./modules/tiposCarne";
import preventistas from "./modules/preventistas.store";
import liquidaciones from "./modules/liquidaciones.store";
import cajasCatalogo from "./modules/cajasCatalogo";
import cajaApertura from "./modules/cajaApertura";
import facturacionPedido from "./modules/facturacionPedido";
import notificaciones from "./modules/notificaciones";
import impuestos from "./modules/impuestos";
import cuentasEmpresa from "./modules/cuentasEmpresa";
import pagosEgresos from "./modules/pagosEgresos";
import conciliacion from "./modules/conciliacion";
import integraciones from "./modules/integraciones";
import publicidad from "./modules/publicidad";
import rutasReparto from "./modules/rutasReparto";
import pedidosPreparar from "./modules/pedidosPreparar";
import gestionPedidos from "./modules/gestionPedidos";
import arca from "./modules/arca";
import permisos from "./modules/permisos";


Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    categorias: [],
    loderCategorias: true,
    subcategorias: [],
    proveedores: [],
    clientes: [],
    loderClientes: true,
    loderPagos: true,
    loderProveedores: true,
    pedidos: [],
    pedidosEnProceso:[],
    pagos: [],
    pagosPaginacion: {
      pagina_actual: 1,
      total_paginas: 1,
      total_registros: 0,
      registros_por_pagina: 50,
      tiene_pagina_anterior: false,
      tiene_pagina_siguiente: false,
    },
    // S8 (T8.11) — reimputación de un cobro a otra cuenta de empresa. Estado propio: no
    // reusa loderPagos/pagosPaginacion (una feature distinta, ver bisstrack-front-conventions).
    reimputarPagoLoading: false,
    reimputarPagoError: null,

  },
  getters: {
    categorias(state) {
      return state.categorias;
    },
    loderCategorias(state) {
      return state.loderCategorias;
    },
    subcategorias(state) {  
      return state.subcategorias;
    },
    proveedores(state) {
      return state.proveedores;
    },
    clientes(state) {
      return state.clientes;
    },
    loderClientes(state) {
      return state.loderClientes;
    },
    loderProveedores(state) {
      return state.loderProveedores;
    },
    loderPagos(state) {
      return state.loderPagos;
    },
    pedidos(state) {
      return state.pedidos;
    },
    pedidosEnProceso(state) {
      return state.pedidosEnProceso;
    },
    pagos(state) {
      return state.pagos;
    },
    pagosPaginacion(state) {
      return state.pagosPaginacion;
    },
    reimputarPagoLoading(state) {
      return state.reimputarPagoLoading;
    },
    reimputarPagoError(state) {
      return state.reimputarPagoError;
    },
  },
  mutations: {
    actulizarTable(state, payload) {
      state[payload[1]][payload[1]].push(payload[0]);
    },
    actulizarTableEdit(state, payload) {
      const indice = state.users.users.findIndex((elemento, indice) => {
        if (elemento.id_usuario === payload.data.id_usuario) {
          return true;
        }
      });
      state.users.users[indice] = payload.data;
      /* console.log("usuario editado",state.users.users[indice])
      console.log("lista final",state.users) */
    },
    actulizarTableDelete(state, payload) {
      const indice = state.users.users.findIndex((elemento, indice) => {
        if (elemento.id_usuario == payload) {
          return true;
        }
      });

      state.users.users.splice(indice, 1);
    },
    setTableDeleteNew(state, { id, table_name, table_field }) {
      return new Promise(async (resolve) => {
        try {
          if (state[table_name][table_name]) {
            state[table_name][table_name] = await state[table_name][
              table_name
            ].filter((elem) => elem[table_field] != id);
          } else {
            state[table_name] = await state[table_name].filter(
              (elem) => elem[table_field] != id
            );
          }
          resolve();
        } catch (e) {
          console.error("error delete", e);
        }
      });
    },
    setDatos(state, payload) {
      return new Promise((resolve) => {
        state.loderClientes = false;
        state.loderProveedores = false;
        state.loderPagos = false;
        state[payload.key] = payload.value;
        resolve();
      });
    },
    SET_PAGOS(state, payload) {
      state.pagos = payload;
    },
    SET_PAGOS_PAGINACION(state, payload) {
      state.pagosPaginacion = payload;
    },
    SET_LODER_PAGOS(state, payload) {
      state.loderPagos = payload;
    },
    SET_LODER_PROVEEDORES(state, payload) {
      state.loderProveedores = payload;
    },
    SET_LODER_CLIENTES(state, payload) {
      state.loderClientes = payload;
    },
    SET_LODER_CATEGORIAS(state, payload) {
      state.loderCategorias = payload;
    },
    SET_REIMPUTAR_PAGO_LOADING(state, payload) {
      state.reimputarPagoLoading = payload;
    },
    SET_REIMPUTAR_PAGO_ERROR(state, payload) {
      state.reimputarPagoError = payload;
    },
  },
  actions: {  
    actulizarData(context, payload) {
      context.commit("actulizarTable", payload);
    },
    actulizarDataEdit(context, payload) {
      context.commit("actulizarTableEdit", payload);
    },
    actulizarDataDelete(context, payload) {
      context.commit("actulizarTableDelete", payload);
    },
    actulizarDataDeleteNew({ commit }, payload) {
      commit("setTableDeleteNew", payload);
    },
    getCategorias({ commit, state }) {
      return new Promise(async (resolve, reject) => {
        try {
          state.loderCategorias = true;
          let r = await axios.get(process.env.VUE_APP_BASE_URL + "productos/categorias");

          commit("setDatos", {
            key: "categorias",
            value: r.data,
          });
          commit("SET_LODER_CATEGORIAS", false);
          resolve();
        } catch (e) {
          console.error(e);
          commit("SET_LODER_CATEGORIAS", false);
          reject(e);
        }
      });
    },
    getSubCategorias({ commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          let r = await subcategoriasService.listar();
          commit("setDatos", {
            key: "subcategorias",
            value: r.data,
          });
          resolve();
        } catch (e) {
          console.error(e);
          reject(e);
        }
      });
    },
    getProveedores({ commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          let r = await axios.get(process.env.VUE_APP_BASE_URL + "proveedores");
          commit("setDatos", {
            key: "proveedores",
            value: r.data,
          });
          resolve();
        } catch (e) {
          console.error(e);
          commit("SET_LODER_PROVEEDORES", false);
          reject(e);
        }
      });
    },
    getClientes({ commit, state }, refresh) {
      return new Promise(async (resolve, reject) => {
        try {
          if (state.clientes.length !== 0 && !refresh) {
            resolve();
            return;
          }
          state.loderClientes = true;
          state.clientes = [];
          let r = await axios.get(process.env.VUE_APP_BASE_URL + "clientes");
          commit("setDatos", {
            key: "clientes",
            value: r.data,
          });
          resolve();
        } catch (e) {
          console.error(e);
          commit("SET_LODER_CLIENTES", false);
          reject(e);
        }
      });
    },
    
    // Acepta un objeto de filtros/paginación (page, limit, id_pago, nro_boleta,
    // fecha_desde, fecha_hasta, id_medio_pago, id_vendedor, id_cliente, id_repartidor)
    // y los pasa como querystring. El back responde { success, data, paginacion }.
    async getPagos({ commit }, params = {}) {
      try {
        commit("SET_LODER_PAGOS", true);
        const { data } = await http.get("cobros", { params });
        commit("SET_PAGOS", data.data || []);
        commit("SET_PAGOS_PAGINACION", data.paginacion || null);
        return data;
      } catch (e) {
        console.error(e);
        throw e;
      } finally {
        commit("SET_LODER_PAGOS", false);
      }
    },

    // S8 (T8.11) — reimputa un cobro a otra cuenta (REQ-REI-001/002/003). Contrato del
    // backend (pagos_service.reimputarPago): POST cobros/:id_pago/reimputar
    // { id_cuenta_destino, motivo, id_medio_pago_destino? } -> { data: { pago, id_cuenta_origen,
    // id_cuenta_destino, movimientos } }, con movimientos === null cuando el cobro todavía no
    // fue rendido (ADR-04: no hay crédito que compensar, sólo se reestampa la cuenta).
    // Loading/error propios: no reutiliza SET_LODER_PAGOS (listado) para no pisar el estado de
    // otra vista.
    //
    // `id_medio_pago_destino` (Trello #350) es opcional: sólo se manda cuando la reimputación
    // también corrige el medio de pago del cobro (ej. cobrado por Mercado Pago pero cargado
    // como Efectivo) — sin él el comportamiento es exactamente el de antes.
    async reimputarPago({ commit }, { id_pago, id_cuenta_destino, motivo, id_medio_pago_destino } = {}) {
      try {
        commit("SET_REIMPUTAR_PAGO_LOADING", true);
        commit("SET_REIMPUTAR_PAGO_ERROR", null);
        const body = { id_cuenta_destino, motivo };
        if (id_medio_pago_destino != null) body.id_medio_pago_destino = id_medio_pago_destino;
        const { data } = await http.post(`cobros/${id_pago}/reimputar`, body);
        return data;
      } catch (e) {
        commit(
          "SET_REIMPUTAR_PAGO_ERROR",
          e.response?.data?.msg || e.message || "Error al reimputar el cobro"
        );
        throw e;
      } finally {
        commit("SET_REIMPUTAR_PAGO_LOADING", false);
      }
    },
  },
  modules: {
    user,
    users,
    productos,
    marcas,
    pedidosModule,
    customers,
    listasPrecio,
    pos,
    discountCodes,
    tiposCarne,
    preventistas,
    liquidaciones,
    cajasCatalogo,
    cajaApertura,
    facturacionPedido,
    notificaciones,
    impuestos,
    cuentasEmpresa,
    pagosEgresos,
    conciliacion,
    integraciones,
    publicidad,
    rutasReparto,
    pedidosPreparar,
    gestionPedidos,
    arca,
    permisos,
  },
});

// Root `logout` is committed from the user action, from http.js (401) and from
// App.vue; subscribing is the one place that catches all three (#385).
store.subscribe(({ type }) => {
  if (type === "logout") store.commit("permisos/RESET_ALL");
});

export default store;
